<template>
<div class="ChannelList">
    <npHeader :param="param" @toggleTab="toggleTab" :flag="flag" :title="title"></npHeader>
    <div class="outbox">
        <div class="filters">
            <div class="add">
                <el-button type="primary" @click="handleAdd">添加渠道</el-button>
            </div>
            <div class="search"></div>
        </div>
        <div class="result-list btn-operate-list bgc">
            <el-table :data="tableData" style="width: 100%;">
                <el-table-column label="渠道名称" class-name="title" min-width="240" prop="name"></el-table-column>
                <el-table-column label="管理员" prop="adminusername" min-width="120">
                    <template slot-scope="scope">
                        <div class="textImage">
                            <img v-lazy="scope.row.adminuserheadurl" alt="" class="img" v-if="scope.row.adminuserheadurl">
                            <span>{{scope.row.adminusername}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="用户数" prop="usercount" class-name="center"></el-table-column>
                <el-table-column label="订单数" prop="ordercount"  class-name="center"></el-table-column>
                <el-table-column label="创建时间" prop="datetime" width="180"  class-name="center"></el-table-column>
                <el-table-column label="操作" min-width="150"   label-class-name="tr">
                    <template slot-scope="scope">
                        <div class="tr">
                        <span class="separator-btn">
                            <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                        </span>
                        <span class="separator-btn">
                            <el-button @click="handleShare(scope.row)" type="text" size="small">分享</el-button>
                        </span>
                        <span class="separator-btn">
                            <el-dropdown>
                                <span class="el-dropdown-link">
                                    <el-button type="text" size="small">更多</el-button>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item @click.native="handleToOrder(scope.row)">订单列表</el-dropdown-item>
                                    <el-dropdown-item @click.native="handleToUser(scope.row)">用户列表</el-dropdown-item>
                                    <el-dropdown-item @click.native="handleDel(scope.row)">删除渠道</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination background @current-change="handleSizeChange" :current-page.sync="page.page" :page-size="page.pageSize" :pager-count="11"
                               layout="prev, pager, next" :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
    <el-dialog title="链接查看" :visible.sync="dialogVisible" @close="cancel" width="600px">
        <div class="share">
            <div class="box">
                <img :src="item.eventshareurlImg" :alt="item.title">
                <div class="pr-code-text cursor" @click="download(item.eventshareurlImg, item.title)">下载<span class="tc-blue blod">活动详情</span>二维码</div>
                <el-input v-model.trim="item.eventshareurl" placeholder="" disabled></el-input>
                <el-button  type="primary" size="mini" v-clipboard:copy="item.eventshareurl" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
            </div>
        </div>
    </el-dialog>
</div>
</template>

<script>
import NpHeader from 'views/tools/nationalDistribution/components/npHeader.vue'
import {mapGetters, mapActions} from 'vuex'
import {getDisChannelList, delChannel} from  'api/nationalDistribution'
import {urlToQRCode, downloadImage} from 'common/js/tools'
import {nationalDistribution} from 'api/message'
export default {
    name: 'ChannelList',
    data() {
        return {
            title: '渠道管理',
            tableData: [],
            page:{
                page: 1,
                pageSize: 10
            },
            param: {
                eventinnerid: this.$route.query.id ? this.$route.query.id : '',
                keywords: '',
                chname: '',
                title: this.$route.query.title ? this.$route.query.title : ''
            },
            total: 0,
            flag: true,
            dialogVisible: false,
            item: {
                title: '',
                eventshareurl: '',
                eventshareurlImg: ''
            }
        }
    },
    mounted() {
        this._getList()
    },
    methods: {
        toggleTab() {
            this.param.keywords = ''
            this.setParams(this._.cloneDeep(this.param))
        },
        cancel() {
            this.dialogVisible = false
            this.item = {
                title: '',
                eventshareurl: '',
                eventshareurlImg: ''
            }
        },
        handleAdd() {
            this.$router.push({name: 'NDActivityChannelEdit', query: {id: this.param.eventinnerid}})
        },
        handleToOrder (row) {
            this.$router.push({name: 'NDActivityOrder', query: {id: this.param.eventinnerid, title: this.param.title, chname: row.name}})
        },
        handleToUser (row) {
            this.$router.push({name: 'NDActivityUser', query: {id: this.param.eventinnerid, title: this.param.title, chname: row.name}})
        },
        handleSizeChange() {
            this._getList()
        },
        handleEdit(row) {
            this.$router.push({name: 'NDActivityChannelEdit', query: {id: this.param.eventinnerid, innerid: row.innerid}})
        },
        handleDel(row) {
            this.$confirm(nationalDistribution.channelDel.msg, nationalDistribution.channelDel.title, {
                confirmButtonText: nationalDistribution.channelDel.confirmText,
                cancelButtonText: nationalDistribution.channelDel.cancelText
            }).then(() => {
                this._del(row.innerid, nationalDistribution.channelDel.successMsg)
            }).catch(() => {})
        },
        handleShare(row) {
            this.item.title = this.param.title
            this.item.eventshareurl = row.shareurl
            this.item.eventshareurlImg = urlToQRCode(row.shareurl)
            this.dialogVisible = true
        },
        download(imgsrc, name) { // 下载图片地址和图片名
            downloadImage(imgsrc, name)
        },
        onCopy(e) {
            this.$message({
                message: '复制成功',
                type: 'success'
            })
        },
        onError(e) {
            alert('失败')
        },
        _del(innerid, tip) {
            this.setLoading(true)
            delChannel({
                data: {
                    eventinnerid: this.param.eventinnerid,
                    innerid: innerid
                },
                success: data => {
                    this.$message.success(tip)
                    this._getList()
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getDisChannelList({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setParams', 'setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        NpHeader
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.ChannelList {
    .outbox{
        margin-top: 24px;
        background: #fff;
        padding: 20px;
        .textImage{
            display: flex;
            align-items: center;
            .img{
                width: 50px;
                height: 50px;
                border-radius: 50%;
                margin-right: 10px;
            }
        }
    }
    .filters {
        margin-top: 0;
        margin-bottom: 20px;
        .search{
            flex-grow: 1;
            .search-input{
                .el-input{
                    width: 240px;
                }
            }
        }
    }
    .page {
        margin-top: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .el-table{
        .title{
            .cell{
                padding: 0;
                margin-left: 5px;
            }
        }
        .center{
            .cell{
                text-align: center;
            }
        }
    }

    .share{
        @include flexBox(space-around);
        .box{
            display: flex;
            flex-direction: column;
            justify-content: center;
            text-align: center;
            .el-input{
                margin: 10px 0;
            }
        }
        .box+.box{
            margin-left: 20px;
        }
    }
}
</style>
